function envFlag(value: string | undefined, fallback = false) {
  if (!value) {
    return fallback;
  }

  const normalized = value.trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
}

export const ORG_WORKSPACE_MIN_VERSION = '1.6.0';

export const APP_FEATURES = {
  search: envFlag(process.env.EXPO_PUBLIC_FEATURE_SEARCH, true),
  orgWorkspaceMinVersion: ORG_WORKSPACE_MIN_VERSION,
} as const;
